import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { UserProfile } from '../types/user-profile';

@Component({
  moduleId: module.id,
  selector: 'profiles',
  templateUrl: './profiles.component.html',
  styleUrls: ['./profiles.component.css'],
  providers: [VoxPopService],
})


export class ProfilesComponent implements OnInit {
  CanReview = ProfileService.CanReview;
  CanAdminister = ProfileService.CanAdminister;
  adding: boolean = false;
  profiles: UserProfile[];
  allProfiles: UserProfile[];
  errorMessage: any;

  constructor(
    private voxPopService: VoxPopService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;
    this.getProfiles();
  }

  getProfiles(): void {
    this.voxPopService.allProfiles().subscribe(
      profiles => this.updatedProfiles(profiles),
      error => this.errorMessage = <any>error,
    );
  }

  private updatedProfiles(newProfiles: UserProfile[]): void {
    this.allProfiles = newProfiles;
    this.profiles = newProfiles;
  }

  gotoDetail(profile: UserProfile): void {
    this.router.navigate([`/review/profile/`, profile.type, profile.id]);
  }

  addProfile(): void {
    this.adding = true;
  }

  closeDetail(): void {
    this.adding = false;
    this.getProfiles();
  }

  getColorFor(profile: UserProfile): string {
    if (this.errorMessage) return '#ff8080'; // So editor doesn't make me think this can be static
    if (profile.administer) return '#e0fff0';
    if (profile.review) return '#e0f8f8';
    return '#EEEEEE';
  }

}

